import {WEB_USER_TOKEN, PY_WEB_UPDATE_TIMESTAMP} from '../constants/LocalStorageKey'
import {USER_TOKEN_HEADER_NAME, DEVICE_ID_HEADER_NAME, PLATFORM_HEADER_NAME, DEVICE_MODEL_HEADER_NAME, APP_VERSION_HEADER_NAME, WEB_UPDATE_TIMESTAMP} from '../constants/HttpParams'
let headerNames = {
  USER_TOKEN_HEADER_NAME: USER_TOKEN_HEADER_NAME,
  DEVICE_ID_HEADER_NAME: DEVICE_ID_HEADER_NAME,
  PLATFORM_HEADER_NAME: PLATFORM_HEADER_NAME,
  DEVICE_MODEL_HEADER_NAME: DEVICE_MODEL_HEADER_NAME,
  APP_VERSION_HEADER_NAME: APP_VERSION_HEADER_NAME,
  WEB_UPDATE_TIMESTAMP: WEB_UPDATE_TIMESTAMP
}
let localStorageKeys = {
  PYCRM_USER_TOKEN: WEB_USER_TOKEN,
  PYAMC_WEB_UPDATE_TIMESTAMP: PY_WEB_UPDATE_TIMESTAMP
}
let ajax = {
  xhr: null,
  callback: null,
  init: function () {
    if (!this.xhr) {
      this.xhr = new XMLHttpRequest()
      let ajax = this
      this.xhr.onreadystatechange = () => {
        if (ajax.xhr.readyState === 4 && ajax.xhr.status === 200) {
          let response = ajax.xhr.responseText === '' ? null : JSON.parse(ajax.xhr.responseText)
          ajax.callback(response)
        }
      }
    }
  },
  synGet: function (url, data, callback) {
    this.init()
    let deviceIdData = data.deviceId
    console.log(deviceIdData)
    let deviceId = deviceIdData || 'string'
    let deviceModel = 'pc'
    let platform = 'windows'
    let webUpdateTimestamp = localStorage.getItem(localStorageKeys.PYAMC_WEB_UPDATE_TIMESTAMP)
    if (!webUpdateTimestamp) {
      webUpdateTimestamp = 0
    }
    this.xhr.open('GET', url, false)
    if (localStorage.getItem(WEB_USER_TOKEN)) {
      this.xhr.setRequestHeader(headerNames.USER_TOKEN_HEADER_NAME, localStorage.getItem(WEB_USER_TOKEN))
      this.xhr.setRequestHeader(headerNames.DEVICE_ID_HEADER_NAME, deviceId)
      this.xhr.setRequestHeader(headerNames.APP_VERSION_HEADER_NAME, '0.0.1-beta')
      this.xhr.setRequestHeader(headerNames.DEVICE_MODEL_HEADER_NAME, deviceModel)
      this.xhr.setRequestHeader(headerNames.PLATFORM_HEADER_NAME, platform)
    }
    this.xhr.setRequestHeader(headerNames.WEB_UPDATE_TIMESTAMP, '' + webUpdateTimestamp)
    this.callback = callback
    this.xhr.send()
  },
  synPost: function (url, data, callback) {
    this.init()
    let deviceId = 'string'
    let deviceModel = 'pc'
    let platform = 'windows'
    let webUpdateTimestamp = localStorage.getItem(localStorageKeys.PYAMC_WEB_UPDATE_TIMESTAMP)
    if (!webUpdateTimestamp) {
      webUpdateTimestamp = 0
    }
    this.xhr.open('POST', url, false)
    this.xhr.setRequestHeader('Content-Type', 'application/json;charset=UTF-8')
    if (localStorage.getItem(WEB_USER_TOKEN)) {
      this.xhr.setRequestHeader(headerNames.USER_TOKEN_HEADER_NAME, localStorage.getItem(WEB_USER_TOKEN))
      this.xhr.setRequestHeader(headerNames.DEVICE_ID_HEADER_NAME, deviceId)
      this.xhr.setRequestHeader(headerNames.APP_VERSION_HEADER_NAME, '0.0.1-beta')
      this.xhr.setRequestHeader(headerNames.DEVICE_MODEL_HEADER_NAME, deviceModel)
      this.xhr.setRequestHeader(headerNames.PLATFORM_HEADER_NAME, platform)
    }
    this.xhr.setRequestHeader(headerNames.WEB_UPDATE_TIMESTAMP, '' + webUpdateTimestamp)
    this.callback = callback
    this.xhr.send(JSON.stringify(data))
  }
}
export default ajax



// WEBPACK FOOTER //
// ./src/apis/ajax.js